import React from 'react';

export const WorkCustomIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.96 10.5C12.1766 10.5 12.3268 10.5999 12.4102 10.7998L13.0098 12.1748L14.46 12.2998C14.6933 12.3331 14.8391 12.4504 14.8975 12.6504C14.9556 12.8502 14.9018 13.0249 14.7354 13.1748L13.6348 14.125L13.96 15.5752C14.0099 15.7918 13.9474 15.9663 13.7725 16.0996C13.5975 16.2329 13.4186 16.2416 13.2354 16.125L11.96 15.3496L10.6855 16.125C10.5022 16.2417 10.3225 16.2329 10.1475 16.0996C9.97278 15.9664 9.91009 15.7916 9.95996 15.5752L10.2852 14.125L9.18555 13.1748C9.019 13.0249 8.96433 12.8502 9.02246 12.6504C9.08078 12.4504 9.22674 12.3332 9.45996 12.2998L10.9102 12.1748L11.5098 10.7998C11.5931 10.5999 11.7434 10.5001 11.96 10.5Z"
      fill="#232C35"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14 2C14.55 2 15.0204 2.19622 15.4121 2.58789C15.8038 2.97956 16 3.45 16 4V6H20C20.55 6 21.0204 6.19622 21.4121 6.58789C21.8038 6.97956 22 7.45 22 8V19C22 19.55 21.8038 20.0204 21.4121 20.4121C21.0204 20.8038 20.55 21 20 21H4C3.45 21 2.97956 20.8038 2.58789 20.4121C2.19622 20.0204 2 19.55 2 19V8C2 7.45 2.19622 6.97956 2.58789 6.58789C2.97956 6.19622 3.45 6 4 6H8V4C8 3.45 8.19622 2.97956 8.58789 2.58789C8.97956 2.19622 9.45 2 10 2H14ZM4 19H20V8H4V19ZM10 6H14V4H10V6Z"
      fill="#232C35"
    />
  </svg>
);
